import { InputConfig, validateEmail } from "@cpj-ai/panel-npm-package";
import TermOfUseLabel from "./TermOfUseLabel";

export const defaultValues = {
  firstName: "",
  lastName: "",
  email: "",
  termsOfUse: false,
};

export const inputConfigs: InputConfig[] = [
  {
    name: "firstName",
    previewSize: {
      md: 6,
      sm: 12,
    },
    inputProps: {
      type: "text",
      label: "First name:",
      placeholder: "Enter first name",
    },
    rules: {
      required: "First Name is required",
      maxLength: {
        value: 50,
        message: "First Name is too long",
      },
      pattern: {
        value: /^[a-zA-Z\s]+$/,
        message: "First Name must contain only English letters",
      },
    },
  },
  {
    name: "lastName",
    previewSize: {
      md: 6,
      sm: 12,
    },
    inputProps: {
      type: "text",
      label: "Last name:",
      placeholder: "Enter last name",
    },
    rules: {
      required: "Last Name is required",
      maxLength: {
        value: 50,
        message: "Last Name is too long",
      },
      pattern: {
        value: /^[a-zA-Z\s]+$/,
        message: "Last name must contain only English letters",
      },
    },
  },
  {
    name: "email",
    previewSize: 12,
    inputProps: {
      type: "text",
      label: "Email:",
      placeholder: "Enter your email",
    },
    rules: {
      required: "Email is required",
      validate: (value) => {
        const emailResult = validateEmail(value);
        return emailResult.isValid ? true : emailResult.message;
      },
    },
  },
  {
    name: "termsOfUse",
    previewSize: 12,
    inputProps: {
      type: "checkbox",
      label: <TermOfUseLabel />,
      defaultSelected: true,
    },
    rules: {
      required: "You must agree to the terms of use",
    },
  },
];
